import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
	Col,
	DatePicker,
	Form,
	Row,
	Spin,
	Table,
	Button,
	Tooltip,
	Select,
	Input,
	Modal,
	message,
} from "antd";
import { dateInDetail } from "utils/Date";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { createGlobalStyle } from "styled-components";
import {
	BarChartOutlined,
	EyeOutlined,
	InfoCircleOutlined,
	SearchOutlined,
} from "@ant-design/icons";
import { setMinePerformanceList } from "redux/actions";
import { CALL_API } from "common/API";
import PerformanceMatrix from "./Viewperformance/PerformanceMatrix";
import { ReactComponent as ChartBarIcon } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (4).svg";
import { ReactComponent as ChartBarIcon2 } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (2).svg";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import { ButtonFilled } from "reusableComponent/UIButtons";
const { RangePicker } = DatePicker;

const StyledTable = styled(Table)`
  .custom-row-height .ant-table-cell {
    height: 70px;
  }
  .pointer-cursor {
    cursor: pointer;
  }
`;

const MinePerformance = ({ selectedItem }) => {
	const [form] = Form.useForm();
	const history = useHistory();
	const dispatch = useDispatch();
	const userInfo = useSelector(getUserInfo);
	const userDataList = useSelector((state) => getUserList(state)) || [];
	const [filteredData, setFilteredData] = useState([]);
	const [hoveredRow, setHoveredRow] = useState(null);
	const [showDateRange, setShowDateRange] = useState(false);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);
	const [minePerformanceLists, setMinePerformanceLists] = useState([]);
	const { Option } = Select;
	const [selectedDateRange, setSelectedDateRange] = useState(null);
	const [chartModalData, setChartModalData] = useState([]);
	const [isBarChartModalVisible, setIsBarChartModalVisible] = useState(false);
	const [attendLoadingId, setAttendLoadingId] = useState(null);
	const handleBarChartModal = (record, isEmpty) => {
		if (isEmpty) {
			setChartModalData([]); // empty modal
		} else {
			setChartModalData([record]); // chart with data
		}
		setIsBarChartModalVisible(true);
	};

	const handleRowClick = (record) => {
		const currentDate = new Date().toISOString().split("T")[0];
		const start = record?.submissionstartdate?.split("T")[0];
		const end = record?.submissionenddate?.split("T")[0];
		if (
			selectedItem === "performance-contract" &&
			[
				"created",
				"updated",
				"accepted",
				"declined",
				"attended",
				"reviewed",
			].includes(record?.contractstatus)
		) {
			history.push(`/Agreed`, { performanceList: record });
		}
	};

	const hasAttended = filteredData?.some(
		(item) => item.contractstatus === "attended"
	);

	const minePerformanceData = minePerformanceLists;

	useEffect(() => {
		fetchAppraisalMineData();
	}, []);

	const handleFilter = (data) => {
		const selectedTypes = data?.type || [];
		const searchText = (data?.search || "").toLowerCase().trim();
		const selectedDate = data?.date ? moment(data?.date, "DD-MM-YYYY") : null;

		const filtered = minePerformanceData?.filter((item) => {
			const typeMatch =
				selectedTypes.length > 0 ? selectedTypes.includes(item.type) : true;
			const searchMatch = searchText
				? [
					item.roletype,
					item.createdon,
					item.period,
					item.submissionstartdate,
					item.submissionenddate,
					item.status,
				]
					.filter(Boolean)
					.some((field) => field?.toLowerCase().includes(searchText))
				: true;
			const dateMatch = selectedDate
				? selectedDate.isSameOrAfter(moment(item.submissionstartdate)) &&
				selectedDate.isSameOrBefore(moment(item.submissionenddate))
				: true;
			return typeMatch && searchMatch && dateMatch;
		});
		return filtered;
	};

	const handleSelectChange = (value) => {
		setSelectedDateRange(value);
		let filtered = [...minePerformanceData];
		const today = moment().endOf("day");
		if (value === "Last week") {
			const lastWeekStart = moment().subtract(7, "days").startOf("day");
			filtered = minePerformanceData?.filter((item) => {
				const itemDate = moment(item.submissionstartdate, "YYYY-MM-DD");
				return itemDate.isBetween(lastWeekStart, today, null, "[]");
			});
			setShowDateRange(false);
		} else if (value === "Last month") {
			const lastMonthStart = moment().subtract(1, "months").startOf("month");
			const lastMonthEnd = moment().subtract(1, "months").endOf("month");
			filtered = minePerformanceData?.filter((item) =>
				moment(item.submissionstartdate, "YYYY-MM-DD").isBetween(
					lastMonthStart,
					lastMonthEnd,
					null,
					"[]"
				)
			);
			setShowDateRange(false);
		} else if (value === "Last 6 months") {
			const lastSixMonthsStart = moment()
				.subtract(6, "months")
				.startOf("month");
			filtered = minePerformanceData?.filter((item) =>
				moment(item.submissionstartdate, "YYYY-MM-DD").isSameOrAfter(
					lastSixMonthsStart
				)
			);
			setShowDateRange(false);
		} else if (value === "custom") {
			setShowDateRange(true);
			return;
		} else {
			setShowDateRange(false);
			setFromDate(null);
			setToDate(null);
		}
		setFilteredData(filtered);
	};

	useEffect(() => {
		if (minePerformanceData?.length > 0) {
			let filtered = [...minePerformanceData];
			const currentDate = moment();

			if (selectedItem === "performance-management") {
				filtered = filtered.filter((item) => {
					return (
						item.contractstatus === "accepted" ||
						item.contractstatus === "attended" ||
						item.contractstatus === "attenddraft" ||
						(item.contractstatus === "reviewed" && item.contractstatus !== "contractdraft")
					);
				});
			} else {
				filtered = filtered.filter((item) => {
					return (
						item.contractstatus !== "reviewed" &&

						item.contractstatus !== "contractdraft"
					);
				});
			}

			if (fromDate && toDate) {
				filtered = filtered.filter((item) => {
					const itemDate = moment(item.submissionstartdate, "YYYY-MM-DD");
					return (
						itemDate.isSameOrAfter(fromDate) && itemDate.isSameOrBefore(toDate)
					);
				});
			}

			setFilteredData(filtered);
		}
	}, [fromDate, toDate, minePerformanceData, selectedItem]);

	const handleFormChange = () => {
		const values = form.getFieldsValue();
		setFilteredData(handleFilter(values));
	};

	const typeOptions = Array.from(
		new Set(minePerformanceData?.map((item) => item.type).filter(Boolean))
	).map((type) => ({ value: type, label: type }));

	// useEffect(() => {
	//   if (minePerformanceData?.length > 0) {
	//     setFilteredData(minePerformanceData);
	//   }
	// }, [minePerformanceData]);

	const normalizePerformanceList = (data) =>
		data.map((item) => ({
			...item,
			type: item.roletype,
			createdon: item.createdat,
			period: item.period,
			submissionstartdate: item.attendstartdate,
			submissionenddate: item.attendenddate,
			attendedon: item.attendedon || null,
			status: item.contractstatus,
			key: item.contractid,
		}));

	const fetchAppraisalMineData = async (draftContractId = null) => {
		try {
			// Build URL: append contractid only when filtering for attenddraft
			const url = draftContractId
				? `appraisal/appraiseemine?userid=${userInfo?.userid}&contractid=${draftContractId}`
				: `appraisal/appraiseemine?userid=${userInfo?.userid}`;

			const response = await CALL_API(url, "get");

			if (response?.code === "SUCCESS") {
				const totalAppraisal = userDataList?.find(
					(val) => val?.userid === userInfo?.userid
				)?.appraisalInformation;

				const activeAppraisal = totalAppraisal?.filter(
					(item) => item?.appraisal === "Yes"
				);

				const appraiserid = activeAppraisal?.map((user) => user?.appraiser);

				const normalized = normalizePerformanceList(
					response.performanceContractList?.filter((val) => {
						if (val?.contractstatus === "reviewed") return true;

						// 👇 If we came back from a draft save, only show that specific draft
						if (draftContractId && val?.contractstatus === "attenddraft") {
							return val?.contractid === draftContractId;
						}

						const isCurrentAppraiser = appraiserid?.includes(val?.appraisarmailid);
						return isCurrentAppraiser;
					}) || []
				);

				setMinePerformanceLists(normalized);
			}
		} catch (error) {
			console.error("API Error:", error);
		}
	};

	const paginationOptions = {
		showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
		pageSize: 20,
		showSizeChanger: false,
	};

	const allReviewed = minePerformanceData?.every(
		(item) => item.contractstatus === "reviewed"
	);

	// Update handleAttendClick
	const handleAttendClick = async (record) => {
		try {
			setAttendLoadingId(record.contractid);

			const url = `appraisal/appraiseemine?userid=${userInfo?.userid}&contractid=${record.contractid}`;
			const response = await CALL_API(url, "get");

			if (response?.code === "SUCCESS") {
				const contractList = response.performanceContractList || [];

				// Find the attend draft data for this contract
				const attendDraftData = contractList.find(
					(item) => item.contractid === record.contractid
				);

				// Merge the enriched attend draft fields INTO the original record
				// record has contractstatus, roletype etc; attendDraftData has saved form fields
				const mergedRecord = attendDraftData
					? {
						...record,                          // keeps contractstatus, roletype, all original fields
						technicalassessment: attendDraftData.technicalassessment || [],
						softskills: attendDraftData.softskills || [],
						successionplanning: attendDraftData.successionplanning || [],
						individualassessment: attendDraftData.individualassessment || [],
						overallsummary: attendDraftData.overallsummary || "",
					}
					: record;

				history.push({
					pathname: `/attend/${record.contractid}`,
					state: {
						data: mergedRecord,       // ✅ has contractstatus + all saved draft fields
						roletype: record.roletype,
					},
				});
			} else {
				message.error("Failed to fetch contract data.");
			}
		} catch (error) {
			message.error("Something went wrong.");
		} finally {
			setAttendLoadingId(null);
		}
	};

	const columns = [
		{
			title: "Role Type",
			dataIndex: "type",
			key: "type",
			width: "10%",
			align: "center",
		},
		{
			title: "Created On",
			dataIndex: "createdon",
			key: "createdon",
			width: "10%",
			align: "center",
			render: (text) => {
				if (!text) {
					return "-";
				}
				return moment(text).format("Do MMM, YYYY");
			},
		},
		{
			title: "Period",
			dataIndex: "period",
			key: "Period",
			width: "10%",
			align: "center",
		},
		{
			title: "From",
			dataIndex: "submissionstartdate",
			key: "submissionstartdate",
			align: "center",
			width: "10%",
			render: (val) => {
				if (!val) return "-";
				const { date: day_th, shortMonthName, year } = dateInDetail(val);
				return `${day_th} ${shortMonthName} ${year}`;
			},
		},
		{
			title: "Due",
			dataIndex: "submissionenddate",
			key: "submissionenddate",
			align: "center",
			width: "10%",
			render: (val) => {
				if (!val) return "-";
				const { date: day_th, shortMonthName, year } = dateInDetail(val);
				return `${day_th} ${shortMonthName} ${year}`;
			},
		},
		...(hasAttended
			? [
				{
					title: "Attended On",
					dataIndex: "attendedon",
					key: "attendedon",
					width: "20%",
					align: "center",
					render: (val) => (val ? moment(val).format("Do MMM, YYYY") : "-"),
				},
			]
			: []),
		{
			title: "Status",
			dataIndex: "contractstatus",
			key: "status",
			width: "20%",
			align: "center",
			render: (_, record) => {
				const currentDate = new Date().toISOString().split("T")[0];
				const start = record?.submissionstartdate?.split("T")[0];
				const end = record?.submissionenddate?.split("T")[0];

				const { contractstatus, agreestatus, appraiserreview } = record;

				if (["created", "resend", "updated"].includes(contractstatus)) {
					return <span style={{ color: "red" }}>Yet to accept</span>;
				}
				if (contractstatus === "accepted") {
					if (
						selectedItem === "performance-management" &&
						currentDate >= start
					) {
						return <span style={{ color: "red" }}>Yet to Attend</span>;
					} else if (
						selectedItem === "performance-management" &&
						currentDate < start
					) {
						return "Not Open";
					} else {
						return "Accepted";
					}
				}
				if (contractstatus === "attenddraft") {
					return <span style={{ color: "#faad14" }}>Draft</span>;
				}
				if (
					contractstatus === "attended" &&
					selectedItem === "performance-management"
				) {
					return "Appraiser Review Pending";
				} else if (
					(contractstatus === "attended" || contractstatus === "draft") &&
					selectedItem === "performance-contract"
				) {
					return "Accepted";
				}
				if (contractstatus === "reviewed") return "Closed";
				if (contractstatus === "declined") return "Declined";

				if (["Pending", "Completed"].includes(appraiserreview)) {
					const path =
						appraiserreview === "Completed"
							? `/ViewCompleted/${record.contractid}`
							: `/view/${record.contractid}`;
					return (
						<StyledButton type="primary" onClick={() => history.push(path)}>
							<EyeOutlined
								style={{ fontSize: "20px", position: "relative", top: "-2px" }}
							/>{" "}
							View
						</StyledButton>
					);
				}
				return contractstatus || "N/A";
			},
		},
		{
			title: "Action",
			key: "action",
			width: "10%",
			align: "center",
			render: (_, record) => {
				const { contractstatus } = record;
				let buttonText = null;
				let targetPath = null;
				let icon = null;
				let tooltip = null;
				let routeState = {};
				let extraIcon = null;

				const isPM = selectedItem === "performance-management";

				const currentDate = new Date().toISOString().split("T")[0];
				const start = record?.submissionstartdate?.split("T")[0];
				const end = record?.submissionenddate
					? moment(record.submissionenddate).format("YYYY-MM-DD")
					: "";

				console.log(contractstatus, "contractstatus")
				switch (contractstatus) {
					case "accepted":
						if (isPM) {
							if (currentDate >= start && currentDate <= end) {
								buttonText = "Attend";
								targetPath = `/attend/${record.contractid}`;
								routeState = { data: record, roletype: record.roletype };
							} else if (currentDate > end) {
								extraIcon = (
									<Tooltip title="The Contract period has expired. You can no longer attend this Contract.">
										<InfoCircleOutlined
											style={{ fontSize: 18, color: "#ff4d4f" }}
										/>
									</Tooltip>
								);
							} else if (currentDate < start) {
								extraIcon = (
									<Tooltip title="You have accepted the contract, but the appraisal period has not started yet. You will be able to submit your self-appraisal once the appraisal window opens.">
										<InfoCircleOutlined
											style={{ fontSize: 18, color: "#1890ff" }}
										/>
									</Tooltip>
								);
							}
						} else {
							if (currentDate < start) {
								buttonText = "View";
								icon = <EyeOutlined style={{ marginRight: 4 }} />;
								targetPath = `/Agreed`;
								routeState = { performanceList: record };
								extraIcon = (
									<Tooltip title="The Contract includes the targets you agreed to achieve for the upcoming period. You can attend this Contract form once the Start Date arrives.">
										<InfoCircleOutlined
											style={{ fontSize: 18, color: "#1890ff" }}
										/>
									</Tooltip>
								);
							}
							buttonText = "View";
							icon = <EyeOutlined style={{ marginRight: 4 }} />;
							targetPath = `/Agreed`;
							routeState = { performanceList: record };
						}
						break;

					case "declined":
						buttonText = "View";
						icon = <EyeOutlined style={{ marginRight: 4 }} />;
						targetPath = `/Agreed`;
						routeState = { performanceList: record };
						extraIcon = (
							<Tooltip title="The appraiser will resend the contract with changes">
								<InfoCircleOutlined
									style={{ fontSize: 18, color: "#1890ff" }}
								/>
							</Tooltip>
						);
						break;
					case "attenddraft":
						if (isPM) {
							buttonText = "Attend";
							targetPath = `/attend/${record.contractid}`;
							routeState = {
								data: record,
								roletype: record.roletype,
							};
						} else {
							buttonText = "View";
							icon = <EyeOutlined style={{ marginRight: 4 }} />;
							targetPath = `/Agreed`;
							routeState = { performanceList: record };
						}
						break;
					case "attended":
						if (isPM) {
							buttonText = "View";
							targetPath = `/viewdetails/${record.contractid}`;
							routeState = {
								appraisalRecord: record,
								data: record,
								roletype: record.roletype,
							};
						} else {
							buttonText = "View";
							targetPath = `/Agreed`;
							routeState = { performanceList: record };
						}

						break;

					case "reviewed":
						buttonText = "View";
						targetPath = `/viewmytabledata/${record.contractid}`;
						routeState = {
							appraisalRecord: record,
							data: record,
							roletype: record.roletype,
							isView: true,
						};
						if (isPM) {
							extraIcon = !allReviewed ? (
								<ChartBarIcon2
									onClick={() => handleBarChartModal(record, false)}
									style={{
										width: "30px",
										height: "30px",
										cursor: "pointer",
										borderRadius: "25px",
										boxShadow:
											"rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
									}}
								/>
							) : (
								<ChartBarIcon
									onClick={() => handleBarChartModal(record, false)}
									style={{
										width: "30px",
										height: "30px",
										cursor: "pointer",
										borderRadius: "25px",
										boxShadow:
											"rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
									}}
								/>
							);
						}
						break;

					case "created":
					case "updated":
					case "resend":
						if (currentDate > end) {
							extraIcon = (
								<Tooltip title="The Contract period has expired. You can no longer accept this Contract.">
									<InfoCircleOutlined
										style={{ fontSize: 18, color: "#ff4d4f" }}
									/>
								</Tooltip>
							);
						} else {
							buttonText = "Review & Accept";
							targetPath = `/reviewagree/${record.contractid}`;
							routeState = { appraisalRecord: record };
						}

						break;

					default:
						return null;
				}

				return (
					<div
						className="action-icons"
						style={{
							display: "inline-flex",
							justifyContent: "center",
							alignItems: "center",
							gap: "8px",
							width: "100%",
						}}
					>
						{extraIcon}
						{buttonText && (
							<ButtonFilled
								loading={buttonText === "Attend" && attendLoadingId === record.contractid} // 👈 spinner only on clicked row
								disabled={buttonText === "Attend" && attendLoadingId !== null}             // 👈 disable all Attend buttons during any fetch
								style={{
									width: "130px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",

								}}
								onClick={(e) => {
									e.stopPropagation();
									if (buttonText === "Attend") {
										handleAttendClick(record);
									} else {
										history.push({ pathname: targetPath, state: routeState });
									}
								}}
							>
								{icon}
								{buttonText}
							</ButtonFilled>
						)}
					</div>
				);
			},
		},
	];

	// Show only the clicked contract's own score — not blended with other
	// roles in the same cycle.
	const clickedContract = chartModalData?.[0];
	const isClickedContractReviewed =
		clickedContract?.contractstatus === "reviewed";
	const averageTechnicalScore = Number(clickedContract?.averagetechnicalscore) || 0;
	const averageSoftScoreForPrimary = Number(clickedContract?.averagesoftscore) || 0;

	return (
		<>
			<Styleddiv>
				{isBarChartModalVisible && (
					<Modal
						centered
						width={1000}
						style={{ borderRadius: "8px", overflow: "hidden" }}
						footer={null}
						title="Overall Performance Matrix"
						visible={isBarChartModalVisible}
						onCancel={() => setIsBarChartModalVisible(false)}
					>
						{isClickedContractReviewed ? (
							<PerformanceMatrix
								Xaxis={averageSoftScoreForPrimary}
								Yaxis={averageTechnicalScore}
							/>
						) : (
							<>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										height: 300,
									}}
								>
									<FolderIcon
										style={{ width: 200, height: 200, marginBottom: 10 }}
									/>{" "}
									<p
										style={{ fontSize: 18, color: "#999", textAlign: "center" }}
									>
										{" "}
										The Appraiser(s) haven't Reviewed the Contract yet
									</p>
								</div>
							</>
						)}
					</Modal>
				)}

				<Row justify="space-between" align="middle">
					<Col>
						<div style={{ fontWeight: 500 }}>
							Total Role {filteredData.length}
						</div>
					</Col>
					<Col flex="auto">
						<Form
							form={form}
							layout="vertical"
							className="mt-2"
							onValuesChange={handleFormChange}
						>
							<Row gutter={12} justify="end">
								<Col xs={24} sm={12} md={8} lg={6} xl={4}>
									<Form.Item name="search">
										<Input
											style={{ borderRadius: 15 }}
											placeholder="Search"
											allowClear
											prefix={
												<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />
											}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={8} lg={6} xl={4}>
									<DropdownCheckBox
										name="type"
										label="Type"
										options={typeOptions}
										form={form}
										handleFormChange={handleFormChange}
									/>
								</Col>

								<Col xs={24} sm={12} md={8} lg={6} xl={4}>
									<Form.Item>
										<Select
											placeholder="Date"
											value={selectedDateRange}
											onChange={handleSelectChange}
											className="custom-select"
											allowClear
										>
											<Option value="Last week">Last Week</Option>
											<Option value="Last month">Last Month</Option>
											<Option value="Last 6 months">Last 6 Months</Option>
											<Option value="custom">Custom</Option>
										</Select>
									</Form.Item>
								</Col>

								{showDateRange && (
									<Col xs={24} sm={24} md={12} lg={8} xl={6}>
										<Form.Item>
											<StyledRangePicker
												format="DD-MM-YYYY"
												onChange={(dates) => {
													setFromDate(dates ? dates[0] : null);
													setToDate(dates ? dates[1] : null);
												}}
											/>
										</Form.Item>
									</Col>
								)}
							</Row>
						</Form>
					</Col>
				</Row>
				<StyledTable
					columns={columns}
					rowClassName={(record, index) => {
						let baseClass =
							index % 2 === 0
								? "custom-row-height"
								: "custom-row-height non-white";
						if (
							record.agreestatus === "Agree" &&
							new Date() < new Date(record.submissionstartdate)
						) {
							return `${baseClass} pointer-cursor`;
						}

						return baseClass;
					}}
					rowKey="id"
					dataSource={filteredData}
					pagination={filteredData?.length > 20 ? paginationOptions : false}
					onRow={(record) => ({
						onClick: (e) => {
							e.stopPropagation();
							handleRowClick(record);
						},
						onMouseEnter: () => setHoveredRow(record.contractid),
						onMouseLeave: () => setHoveredRow(null),
						style: { cursor: "pointer" },
					})}
				// onRow={(record, index) => ({
				//   onClick: () => {
				//     if (selectedItem === "performance-management") {
				//       history.push(`/viewdetails/${record.contractid}`);
				//     }
				//     if (record.appraiser_review === "Pending") {
				//       history.push(`/Agreed${record.key}`);
				//     } else if (
				//       record.agreestatus === "Agree" &&
				//       new Date() < new Date(record.submissionstartdate)
				//     ) {
				//       history.push(`/reviewagree/${record?.contractid}`);
				//     }
				//   },
				//   onMouseEnter: () => setHoveredRow(index),
				//   onMouseLeave: () => setHoveredRow(null),
				// })}
				/>
			</Styleddiv>
		</>
	);
};

export default MinePerformance;

const StyledRangePicker = styled(RangePicker)`
  width: 240px !important;
  border-radius: 24px !important;
  margin-left: 10px;
`;

const GlobalStyles = createGlobalStyle`
  .custom-tooltip .ant-tooltip-arrow {
    display: none !important; /* Hides the arrow */
  }
  .custom-tooltip {
    padding-top: 10px !important; /* Removes unwanted padding */
  }
`;

const StyledButton = styled(Button)`
  width: 130px;
  height: 34px;
`;

const Styleddiv = styled.div`
  .search-type-date {
    display: flex;
    gap: 24px;
  }
  .searchtype {
    width: 176px;
    border-radius: 24px !important;
  }
  .custom-select .ant-select-selection-placeholder {
    color: black !important;
  }

  .custom-select .ant-select-selector {
    border-radius: 24px !important;
    color: black !important;
  }
  .custom-rangepicker .ant-picker {
    border-radius: 24px !important;
    width: 250px !important; /* Adjust width as needed */
  }
  .searchbar {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .type-dropdown {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .date-picker {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .ant-picker-input {
    display: flex;
    align-items: center;
  }

  .ant-picker-suffix {
    order: -1; /* This moves the icon to the front */
    margin-right: 8px; /* Optional: adjust the space between the icon and the placeholder */
  }
  .ant-table-thead > tr > th {
    font-weight: 500;
    font-size: 16px;
  }
  .ant-table-tbody > tr > td {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }

  .action-icons {
    display: inline-flex !important;
    gap: 12px;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #52c41a !important; /* Green */
    border-color: #52c41a !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #52c41a !important;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-inner {
    width: 16px;
    height: 16px;
  }
`;